import React, {Fragment} from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash'
import styled from 'styled-components';
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from 'formik';
import { compose} from "redux";
import hedgeTypeIds, { hedgeTypes } from 'constants/hedgeTypes';
import interestRateTypes from 'constants/interestRateTypes';
import loanTypes from 'constants/loanTypes';
import {SectionTitle} from './FormSectionComponents';
import {
  SideLabelTextAreaWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelMoneyWithRefInput,
  SideLabelAutoCompleteWithRefInput,
  SideLabelPercentInput,
  SideLabelPercentWithRefInput,
  SideLabelAutoCompleteInput,
 } from './FormSectionComponents';

 const StyledGrid = styled(Grid)`
  &&& {
    width:1200px;
  }
`;

const VerticalSpacer = styled.div`
height:30px;
display:block;
`

class HedgeRequirementsSection extends React.Component {
  state ={};

  shouldShowMaxCapStrike(formik){
    return formik.values.details.loanTypeId !== null && formik.values.details.rateTypeId !== null && formik.values.hedgeRequirements.requiredHedgeId !== null &&
           formik.values.details.loanTypeId === loanTypes.FREDDIE_MAC && 
           formik.values.details.rateTypeId === interestRateTypes.FLOATING &&
           formik.values.hedgeRequirements.requiredHedgeId === hedgeTypeIds.CAP;
  }

  render(){    
    const {formik, isEditing, ratingsTriggers, isQuote} = this.props;
    
    return (
      <Fragment>
        <div id="hedge_requirements_section">
          <VerticalSpacer/>
          <SectionTitle id="hedge_requirements_section">Hedge Requirements</SectionTitle>
          <StyledGrid container alignItems="center" direction="column">
            <SideLabelAutoCompleteWithRefInput
              label="Required Hedge"
              id="dropdownForRequiredHedgeType"
              options={hedgeTypes}
              refFieldName="hedgeRequirements.requiredHedgeIdRef"
              selectName="name"
              selectValue="value"
              fieldName="hedgeRequirements.requiredHedgeId"
              hasBorder={true}            
              isDisabled={!isEditing}/>
              
              {isQuote && 
                <SideLabelPercentInput label="Strike" placeholder="Strike" fieldName="hedgeRequirements.strike" isDisabled={!isEditing} decimalScale={2} />}
              
              {isQuote && 
              <SideLabelAutoCompleteInput label="Rating Downgrades" id="dropdownForRatingDowngrades" options={ratingsTriggers} selectName="name" selectValue="value" fieldName="hedgeRequirements.ratingsDowngradesId" hasBorder={true}  isDisabled={!isEditing} />}
              
            <SideLabelMoneyWithRefInput label="Notional" hasBorder placeholder="Notional" fieldName="hedgeRequirements.notional" isDisabled={!isEditing}/>
            <SideLabelIntegerWithRefInput label="Term (Months)" hasBorder placeholder="Term (Months)" fieldName="hedgeRequirements.termMonths" isDisabled={!isEditing}/>
            {this.shouldShowMaxCapStrike(formik) &&
              <SideLabelPercentWithRefInput label="Max Cap Strike" hasBorder placeholder="Max Cap Strike" fieldName="hedgeRequirements.maxCapStrike" isDisabled={!isEditing}/>}
            <SideLabelTextAreaWithRefInput label="Pricing Requirements" hasBorder placeholder="Pricing Requirements" fieldName="hedgeRequirements.pricingRequirements" isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput label="Rating Requirements" hasBorder placeholder="Rating Requirements" fieldName="hedgeRequirements.ratingsRequirements" isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput label="Extensions" hasBorder placeholder="Extensions" fieldName="hedgeRequirements.extensions" isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput label="Collateral Assignment" hasBorder placeholder="Collateral Assignment" fieldName="hedgeRequirements.collateralAssignment" isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput label="Legal Opinion" hasBorder placeholder="Legal Opinion" fieldName="hedgeRequirements.legalOpinion" isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput label="Execution Requirements" hasBorder placeholder="Execution Requirements" fieldName="hedgeRequirements.executionRequirements" isDisabled={!isEditing}/>
            <SideLabelTextAreaWithRefInput label="Misc." placeholder="Misc." fieldName="hedgeRequirements.misc" isDisabled={!isEditing}/>
          </StyledGrid>
        </div>
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
    {
    }
  )
)(HedgeRequirementsSection);
